/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--lvl-2';
    const submenuSelector = '.menu-nav--lvl-2';
    const headerSelector = '.header';
    const activeClass = "active";
    const activeClassHeader = "active-header";
    const parentActiveClass = "active-item";
    const hiddenHeader = "header--hidden";

    let activeSubMenu = null;
    const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);
    const header = document.querySelector(headerSelector);

    const init = () => {
        if (parentMenuItems.length > 0 && header) {
            parentMenuItems.forEach(item => {
                // Handle click event
                item.addEventListener('click', (event) => {
                    const subMenu = item.querySelector(submenuSelector);
                    event.stopPropagation(); // Prevent click from bubbling up

                    if (subMenu) {
                        if (activeSubMenu && activeSubMenu !== subMenu &&
                            !activeSubMenu.contains(event.target)) {
                            closeSubMenu(activeSubMenu);
                        }

                        if (subMenu.classList.contains(activeClass) &&
                            !activeSubMenu.contains(event.target)) {
                            closeSubMenu(subMenu); // Close if already open
                        } else {
                            openSubMenu(subMenu);
                            item.classList.add(parentActiveClass);
                        }
                    } else {
                        if (activeSubMenu) {
                            closeSubMenu(activeSubMenu);
                        }
                    }
                });

                // // Handle Enter key event
                // item.addEventListener('keydown', (event) => {
                //     if (event.key === 'Enter') {
                //         item.click(); // Simulate a click event
                //     }
                // });
            });

            // Close the submenu when clicking outside
            document.addEventListener('click', (event) => {
                if (
                    activeSubMenu &&
                    !header.contains(event.target) &&
                    !activeSubMenu.contains(event.target) // Prevent closing if clicking inside submenu
                ) {
                    closeSubMenu(activeSubMenu);
                }
            });

            // Use MutationObserver to monitor changes to the header classes
            const observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'attributes' && header.classList.contains(hiddenHeader)) {
                        // Close the menu if the hiddenHeader class is active
                        if (activeSubMenu) {
                            closeSubMenu(activeSubMenu);
                        }
                    }
                });
            });

            observer.observe(header, { attributes: true, attributeFilter: ['class'] });
        }
    };

    const openSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', false);
        subMenu.classList.add(activeClass);
        activeSubMenu = subMenu;
        header.classList.add(activeClassHeader);
    };

    const closeSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', true);
        subMenu.classList.remove(activeClass);
        activeSubMenu = null;
        header.classList.remove(activeClassHeader);
        parentMenuItems.forEach(item => item.classList.remove(parentActiveClass)); // Remove active class only when closing
    };

    init();
}
